
import Vue  from 'vue'
import { GlobalFooter as GlobalFooterModule } from '@raksul/raksul-common-ui'
import { ProductCategory } from '@/model/productCategory'
import FacetsList from '@/common/components/facets/FacetsList.vue'
import CategoryMenu from '@/common/components/CategoryMenu.vue'
import { Category } from '@/model/category'
export default Vue.extend({
  components: {
    GlobalFooterModule,
    CategoryMenu,
    FacetsList
  },
  props: {
    productCategories: {
      type: Array as () => ProductCategory[],
      required: true
    },
    jsonRootCategory: {
      type: Object as () => Category,
      required: true
    }
   },
  computed: {
    isMobileWidth(): boolean {
      return window.innerWidth < 1024
    },
    isCategoryPage(): boolean {
      return window.location.pathname.indexOf('categories') > -1
    },
    isTopPage(): boolean {
      return window.location.pathname === '/'
    },
    isShowFacetsList(): boolean {
      return this.isMobileWidth && (this.isCategoryPage || this.isTopPage)
    }
  }
})
